import { FiX } from 'react-icons/fi';
import { GoCircle } from 'react-icons/go';
import styled, { css } from 'styled-components';
import { Col } from '@/components/grid/grid-component';

const StatusCircle = styled(GoCircle)`
  margin-left: 8px;
  ${(props) => {
    switch (props.status) {
      case 'active':
        return css`
          color: ${props.theme.COLOR_STATUS_GREEN};
        `;
      case 'new':
        return css`
          color: ${props.theme.COLOR_STATUS_BLUE};
        `;
      case 'suspended':
        return css`
          color: ${props.theme.COLOR_STATUS_ORANGE};
        `;
      default:
        return null;
    }
  }}
`;

const ImageSection = styled(Col)`
  display: flex;
  flex-direction: column;
`;

const Spacer = styled.div`
  height: 16px;
  background-color: ${({ theme }) => theme.COLOR_BG_DARK};
`;

const Bumper = styled.div`
  height: 24px;
`;

const FlexContainer = styled.div`
  display: flex;
  flex-direction: row;
`;

const SupplierContainer = styled(FlexContainer)``;

const SupplierInputContainer = styled(FlexContainer)`
  gap: 12px;
  align-items: center;
  justify-content: center;
`;

const RemoveSupplierIcon = styled(FiX)`
  cursor: pointer;
  color: #343330;
  margin-top: 10px;
`;

const CompanyFormStyle = {
  ImageSection,
  StatusCircle,
  Spacer,
  Bumper,
  SupplierContainer,
  SupplierInputContainer,
  RemoveSupplierIcon,
};

export default CompanyFormStyle;
